import { render, staticRenderFns } from "./pedidos-item-edit.vue?vue&type=template&id=bfcd0460"
import script from "./pedidos-item-edit.vue?vue&type=script&lang=js"
export * from "./pedidos-item-edit.vue?vue&type=script&lang=js"
import style0 from "./pedidos-item-edit.vue?vue&type=style&index=0&id=bfcd0460&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports